/**
 * Doğum günü kutlama overlay'i.
 *
 * Personel dashboard'a girdiğinde gösterilir.
 * "Kapat" butonu ile gizlenir, oturum boyunca tekrar açılmaz (localStorage).
 */

import { useEffect, useState } from 'react'
import { X, Cake } from 'lucide-react'
import { Konfeti } from './Konfeti'
import { katsayiGetir, type DogumGunuKatsayisi } from '@/lib/services/dogum-service'

interface Props {
  personelId: string
  personelAdi: string
  acik: boolean
  onKapat: () => void
}

export function DogumGunuKutlamasi({ personelId, personelAdi, acik, onKapat }: Props) {
  const [katsayi, setKatsayi] = useState<DogumGunuKatsayisi | null>(null)
  const [yukleniyor, setYukleniyor] = useState(true)

  useEffect(() => {
    if (!acik) return
    setYukleniyor(true)
    katsayiGetir(personelId, new Date().getFullYear())
      .then(setKatsayi)
      .catch(() => setKatsayi(null))
      .finally(() => setYukleniyor(false))
  }, [acik, personelId])

  if (!acik) return null

  return (
    <>
      <Konfeti />
      <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40 p-4 animate-fade-in">
        <div className="bg-gradient-to-br from-pink-500 via-purple-500 to-indigo-600 rounded-3xl shadow-2xl max-w-md w-full p-6 relative animate-slide-up">
          <button
            onClick={onKapat}
            className="absolute top-3 right-3 p-1.5 rounded-full bg-white/20 hover:bg-white/30 text-white transition-colors"
            aria-label="Kapat"
          >
            <X className="w-5 h-5" />
          </button>

          <div className="text-center text-white space-y-4">
            <div className="text-7xl animate-bounce">🎂</div>

            <div>
              <p className="text-sm uppercase tracking-widest opacity-90 font-semibold">
                Bugün senin günün
              </p>
              <h2 className="text-3xl font-black mt-1">
                İYİ Kİ DOĞDUN
              </h2>
              <h3 className="text-4xl font-black mt-1 drop-shadow-lg">
                {personelAdi.toUpperCase()}! 🎉
              </h3>
            </div>

            {yukleniyor ? (
              <div className="bg-white/20 rounded-2xl p-4">
                <div className="inline-block animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
              </div>
            ) : katsayi ? (
              <div className="bg-white/95 rounded-2xl p-4 text-gray-900 shadow-lg">
                <div className="flex items-center justify-center gap-2 mb-2">
                  <Cake className="w-6 h-6 text-pink-600" />
                  <p className="text-sm font-bold uppercase tracking-wide text-pink-700">
                    BOSS'tan sana özel
                  </p>
                </div>
                <p className="text-lg font-semibold">
                  Bugünkü mesain
                </p>
                <p className="text-5xl font-black text-pink-600 my-2">
                  x{katsayi.katsayi}
                </p>
                <p className="text-lg font-semibold">
                  ödenecek! 💰🎁
                </p>
              </div>
            ) : (
              <div className="bg-white/20 rounded-2xl p-4 text-white">
                <p className="text-base">
                  Tüm Shift Beat ekibi seninle birlikte 🎈🎁
                </p>
                <p className="text-sm opacity-90 mt-1">
                  Sağlıkla, mutlulukla nice yıllara! ✨
                </p>
              </div>
            )}

            <button
              onClick={onKapat}
              className="w-full bg-white hover:bg-gray-100 text-purple-700 font-bold py-3 rounded-xl shadow-md transition-colors text-base"
            >
              Teşekkürler! 🥳
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
